const KEY = 'pay-policy-templates.search';

/**
 * The list keeps its search and filters in the URL; the editor reads them back here so
 * "All templates" returns to the same list.
 */
export const rememberListSearch = (query: string) => {
  try {
    if (query) sessionStorage.setItem(KEY, query);
    else sessionStorage.removeItem(KEY);
  } catch {
    // Storage may be unavailable; the list then opens unfiltered.
  }
};

export const listPath = () => {
  let query = '';
  try {
    query = sessionStorage.getItem(KEY) ?? '';
  } catch {
    query = '';
  }
  return query ? `/pay-policy-templates?${query}` : '/pay-policy-templates';
};
